import {
  AxisChartConfig,
  BarChartConfig,
  BarChartPoint,
} from "app/shared/charts/BarChart";
import { Measure } from "../models";

/**
 * Builds working area sampled by hour (from startDate to endDate)
 */
export const buildDrillWorkingAreaChart = (
  startDate: string,
  endDate: string,
  measures: Measure[],
  t: (key: string) => string
) => {
  const bars: BarChartConfig[] = [
    {
      dataKey: "workHours",
      fillColor: "var(--chakra-colors-chart-primary-100)",
      label: t("analyticsDetails.labelDrillingSize"),
      yAxisId: "right",
    },
  ];
  const axis: AxisChartConfig[] = [
    { axisId: "left", label: t("analyticsDetails.labelWorkHours") },
    { axisId: "right", label: t("analyticsDetails.labelDrillingSize") },
  ];
  const data: BarChartPoint[] = [];

  // Build sampling by hour
  let current = new Date(startDate);
  const end = new Date(endDate);

  while (current <= end) {
    data.push({
      timestamp: current.setMinutes(0, 0, 0),
      workHours: 0,
    });

    current.setHours(current.getHours() + 1);
  }

  // Increment sampling values
  let lastValues: Record<string, number> = {};

  measures.forEach((measure) => {
    const timestamp = new Date(measure.timestamp).setMinutes(0, 0, 0);
    const point = data.find((it) => it.timestamp === timestamp);
    const value = Number(measure.value ?? 0);

    // Difference between the last point of same sensor name to check area in the hour.
    // Then convert Millimeter -> Meter.
    if (point) {
      const lastValue = lastValues[measure.name] ?? value;
      point.workHours += (value - lastValue) / 1000;
    }

    lastValues[measure.name] = value;
  });

  return {
    bars,
    data,
    axis,
    timestampTickFormatter: "HH:mm",
    timestampTooltipFormatter: "DD/MM/YYYY HH:mm",
    hideLegend: true,
  };
};
